import TrameSaisieDetailController from './trame.saisie.detail.controller';

export default {
    template: require('./trame.saisie.detail.html'),
    controller: TrameSaisieDetailController
};
